import { PlanNames } from '../../planNames';
export const stripePriceToPlanMap = {
    'price_1MlSiZL2UdqYSxumpDVX34tc': PlanNames.Mini,
    'price_1MlSiUL2UdqYSxumx0rqTw7Y': PlanNames.Starter,
    'price_1MlSiRL2UdqYSxum7MsOtC6k': PlanNames.Professional,
    'price_1MlSiBL2UdqYSxumlgbfHEBZ': PlanNames.Multi,
    'price_1MlShuL2UdqYSxumtJECgSLI': PlanNames.MultiPlus,
};
//# sourceMappingURL=july2023.js.map